import React from 'react';

/**
 * Cambia entre claro y oscuro. El icono muestra a dónde va, no dónde está.
 *
 * `variante="barra"` es para la barra azul de arriba, donde el botón va sobre el azul oscuro
 * como los del sistema interno. Sin variante se pinta como una tarjeta suelta, que es lo que
 * hace falta en la pantalla de entrada, donde el fondo es el degradado.
 */
export default function BotonTema({ tema, alternar, variante }) {
  const aOscuro = tema !== 'dark';
  const enLaBarra = variante === 'barra';

  return (
    <button
      type="button"
      onClick={alternar}
      title={aOscuro ? 'Cambiar a modo oscuro' : 'Cambiar a modo claro'}
      aria-label={aOscuro ? 'Cambiar a modo oscuro' : 'Cambiar a modo claro'}
      className={enLaBarra ? 'btn-barra' : undefined}
      style={enLaBarra ? { padding: '7px 10px', fontSize: 15 } : {
        width: 38, height: 38, display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 16, cursor: 'pointer', borderRadius: 'var(--radio)',
        color: 'var(--negro-texto)', background: 'var(--blanco)',
        border: '1px solid var(--gris-borde)',
      }}
    >
      {aOscuro ? '🌙' : '☀️'}
    </button>
  );
}
